/**
 * Utility to centralize email handling
 */
export class EmailValidator {

  /**
   * the regex to validate the e-mail
   */
  private static REGEX =
    '(?:[a-zA-Z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\\.[a-zA-Z0-9!#$%&\'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-' +
    '\x5b\x5d-\x7f]|\\\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\\.)+[a-zA-Z0-9](?:[a-zA-Z0' +
    '-9-]*[a-zA-Z0-9])?|\\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[' +
    'a-zA-Z0-9-]*[a-zA-Z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\\])';
  private static PWD_REGEX = '^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%^&+!*=])(?=\\S+$).{12,}$';
  /**
   * Determine if an e-mail is valid or not
   * @param {string} email - the email to test
   * @return {boolean} - if it's valid or not
   */
  public static emailIsValid(email: string) {
    return new RegExp(this.REGEX).test(email);
  }
  public static passwordIsValid(passwd: string) {
    return new RegExp(this.PWD_REGEX).test(passwd);
  }
}
